import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/uppsala")(
  heritageCityRoute({
    citySlug: "uppsala",
    angle:
      "I Uppsala dokumenterar vi livsberättelser för familjer och kunskapsarv för forsknings-, life science- och MedTech-bolag — där tyst kunskap ofta sitter hos enskilda specialister.",
    localUseCases: [
      "Livsintervju med förälder eller släkting i Uppsala",
      "Kunskapsöverföring från seniora forskare",
      "Grundarporträtt för MedTech- och life science-bolag",
      "Dokumentation av specialistkunskap inför pension",
      "Företagshistoria för universitetsnära bolag",
      "Minnesfilm och släktarv",
    ],
  }),
);
